<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              <button class="modal-default-button" @click="close">x</button>
              <h3>{{ this.popData.title }}  </h3>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <div class="image-container">
                <!-- <video autoplay muted loop>
                  <source
                    src="../../assets/rupakotcampaign-video-footer.webm"
                    type="video/webm"
                  />
                </video> -->
                <img
                  class="image-wrapper"
                  :src="this.popData.image"
                  alt="popupbanner"
                />
                <!-- <img
                  class="image-wrapper"
                  src="https://manager.khaanpin.com/images/shop/gb_premium_Khanpin_x_GBPL_1024_x_1024.png"
                  alt="popupbanner"
                /> -->
              </div>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <div>
                {{ this.popData.details }}
              </div>
              <div class="button-container">
                <a-button
                  type="primary"
                  @click="handleButton"
                  class="checkout-button"
                >
                  {{ this.popData.button_text }} 
                </a-button>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import router from "../../router";
import { LocationId } from "../../services/storage.service";

export default {
  name: "PopupModal",
  data() {
    return {
      showModal: false,
    };
  },
  props: ["popData"],
  methods: {
    close() {
      this.$emit("close");
    },

    handleButton() {
      this.$emit("close");

      if (this.popData.redirection_type === "search") {
        // let url = "./#/s/" + this.popData.redirection_code;
        // window.open(url, "_blank");

        if (LocationId.getLocationId() == 1) {
          this.$router.replace({
            name: "Search",
            params: { loc: "ktm" },
            query: { q: this.popData.redirection_code },
          });
        } else if (LocationId.getLocationId() == 2) {
          this.$router.replace({
            name: "Search",
            params: { loc: "pkr" },
            query: { q: this.popData.redirection_code },
          });
        }

        // router.push("/ktm/s/" + this.popData.redirection_code);
      } else if (this.popData.redirection_type === "section") {
        router.replace("/ktm/c/" + this.popData.redirection_code);
      } else if (this.popData.redirection_type === "list") {
        router.replace("/ktm/l/" + this.popData.redirection_code);
      } else if (this.popData.redirection_type === "item") {
        router.replace("/ktm/i/" + this.popData.redirection_code);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  position: relative;
  width: 45%;
  height: auto;
  margin: 0px auto;
  padding: 15px 25px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #ed1e29;
  font-family: "Fredoka One", cursive;
  font-size: 24px;
  text-align: center;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  // float: right;
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  background-color: #ed1e29;
  color: #fff;
  border-radius: 20px;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

/*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.image-container {
  width: 100%;

  .image-wrapper {
    width: 100%;
    border-radius: 10px;
  }

  video {
    border-radius: 10px;
    height: 100%;
    width: 100%;
    object-fit: fill;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
  }
}

.modal-footer {
  text-align: center;
  color: gray;
}

.button-container {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkout-button {
  display: inline-block;
  padding: 5px 10px;
  background-color: $brand-color;
  color: white;
  height: auto;
  cursor: pointer;
  font-family: $main-font;
  font-size: 12px;
  border-radius: 30px;
}

@media screen and (max-width: 700px) {
  .modal-header h3 {
    font-size: 20px;
  }

  .modal-container {
    width: 60%;
  }
}

@media screen and (max-width: 400px) {
  .modal-header h3 {
    font-size: 18px;
  }

  .modal-container {
    width: 70%;
  }
}
</style>